module.exports = __webpack_public_path__ + "static/media/06.9e140060.jpg";